import React from "react";

import Svg from "@/styles/Svg";
import { isTouchDevice } from "@/utils/getters";

import { Icon } from "./styles";

export type SharingProps = {
  icons: IIcons;
  onShareClick: (type: SharingType) => void;
  customIconSize?: number;
};

export enum SharingType {
  twitter = "twitter",
  whatsApp = "whatsapp",
  facebook = "facebook",
}

const Sharing: React.FC<SharingProps> = (props: SharingProps): JSX.Element => {
  const { customIconSize, onShareClick, icons } = props;
  const iconSize = customIconSize || 20;
  const mobileIconSize = customIconSize || 22;

  return (
    <React.Fragment>
      <Icon onClick={() => onShareClick(SharingType.facebook)}>
        <Svg contents={icons.Facebook} height={iconSize} width={iconSize} />
      </Icon>
      <Icon onClick={() => onShareClick(SharingType.twitter)}>
        <Svg contents={icons.Twitter} height={iconSize} width={iconSize} />
      </Icon>
      {isTouchDevice() && (
        <Icon onClick={() => onShareClick(SharingType.whatsApp)}>
          <Svg
            contents={icons.WhatsApp}
            height={mobileIconSize}
            width={mobileIconSize}
          />
        </Icon>
      )}
    </React.Fragment>
  );
};

export default Sharing;
